import React from "react";

export class ConfirmModal extends React.Component {
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <div className="app-modal-overlay">
        <div className="app-modal">
          <p className="app-modal-message">{this.props.message}</p>
          <div className="app-modal-actions">
            {this.props.onCancel && (
              <button
                type="button"
                className="btn-default btn-light app-modal-btn"
                onClick={this.props.onCancel}
              >
                {this.props.cancelLabel || "Cancel"}
              </button>
            )}
            {this.props.onConfirm && (
              <button
                type="button"
                className="btn-default app-modal-btn"
                onClick={this.props.onConfirm}
              >
                {this.props.confirmLabel || "Confirm"}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
